/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NatureFxLightningBIcon16Light = forwardRef('NatureFxLightningBIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.664.995C9.107.44 10 .755 10 1.463V6h2.98a.75.75 0 0 1 .585 1.219l-6.23 7.787c-.442.554-1.335.24-1.335-.469V10H3.02a.75.75 0 0 1-.585-1.218L8.665.995ZM9 2.176 3.54 9h2.71a.75.75 0 0 1 .75.75v4.075L12.46 7H9.75A.75.75 0 0 1 9 6.25V2.176Z" })));
});
